module.exports = __webpack_public_path__ + "img/ricelog_pinicon_050.770ad985.png";